import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceBase, OrigamiHttpResponse } from './base/service.base';
import { ErrorCode } from '@app/origami-api/constants/error-codes';
import { QueryTicketStatuses } from '../constants/query-ticket-statuses';
import { AdditionalRequestOptions } from '@app/origami-api/services/base/request-proxy/request-proxy.class';

export interface ResolveQueryTicket {
  siteId: number;
  queryTicketId: number;
  resolutionType: number;
  title: string;
  comments: string;
  queryTicketActivityId?: number;
  queryTicketActivityFileId?: number;
  rejectQueryDocument?: boolean;
  amendmentProfileId?: number;
  document?: {
    TopicId?: number;
    ReplaceAttachmentOnly?: boolean;
    FileToken?: string;
    ReplaceAttachmentReason?: string;
  };
}

export interface GetQueryTicketActivityFile {
  siteId: number;
  queryTicketId: number;
  fileId: number;
}

export interface ResetQueryTicketStatus {
  siteId: number;
  queryTicketId: number;
  statusType: QueryTicketStatuses;
  comments: string;
}

@Injectable()
export class QueryTicketService extends ServiceBase {
  serviceUrl = 'QueryTicketService.svc';

  resolveQueryTicket(
    params: ResolveQueryTicket,
    silentErrorCodes?: ErrorCode[],
    additionalRequestOptions?: AdditionalRequestOptions,
  ): Observable<OrigamiHttpResponse> {
    return this.origamiPost('/ResolveQueryTicket', params, null, silentErrorCodes, true, additionalRequestOptions);
  }

  getQueryTicketActivityFile(params: GetQueryTicketActivityFile): Observable<OrigamiHttpResponse> {
    return this.origamiPost('/GetQueryTicketActivityFile', params, null, [], true);
  }

  resetQueryTicketStatus(params: ResetQueryTicketStatus) {
    return this.origamiPost('/ResetQueryTicketStatus', params, null, null, true);
  }
}
